export default "__VITE_ASSET__9e29eeae__"